module.exports = __webpack_public_path__ + "img/sarah-kilian-52jRtc2S_VE-unsplash.f3166417.jpg";